// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutValues_values__dJU9w {
  background: #f8f9fb;
  padding: 100px 0;
}
.AboutValues_values__dJU9w .AboutValues_grid__PLCBT {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
@media (max-width: 992px) {
  .AboutValues_values__dJU9w .AboutValues_grid__PLCBT {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 700px) {
  .AboutValues_values__dJU9w .AboutValues_grid__PLCBT {
    grid-template-columns: 1fr;
  }
}
.AboutValues_values__dJU9w .AboutValues_card__2Uuf2 {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 40px 30px 40px;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.35s ease, box-shadow 0.35s ease;
  will-change: transform;
  /* shine overlay */
}
.AboutValues_values__dJU9w .AboutValues_card__2Uuf2::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 12px;
  pointer-events: none;
  background: radial-gradient(circle at 30% 20%, rgba(30, 33, 80, 0.12), transparent 55%);
  opacity: 0;
  transition: opacity 0.35s ease;
}
.AboutValues_values__dJU9w .AboutValues_card__2Uuf2 {
  /* hover only desktop */
}
@media (hover: hover) {
  .AboutValues_values__dJU9w .AboutValues_card__2Uuf2:hover {
    transform: translateY(-10px);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.14), 0 0 0 2px rgba(30, 33, 80, 0.1), 0 0 26px rgba(158, 186, 68, 0.18);
  }
  .AboutValues_values__dJU9w .AboutValues_card__2Uuf2:hover::after {
    opacity: 1;
  }
}
.AboutValues_values__dJU9w .AboutValues_card__2Uuf2 .AboutValues_icon__w1VMS {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: static;
  top: auto;
  left: auto;
  transform: none;
  margin-bottom: 22px;
  transition: transform 0.35s ease;
}
.AboutValues_values__dJU9w .AboutValues_card__2Uuf2 .AboutValues_icon__w1VMS img {
  width: 82px;
  height: 82px;
  object-fit: contain;
}
@media (hover: hover) {
  .AboutValues_values__dJU9w .AboutValues_card__2Uuf2:hover .AboutValues_icon__w1VMS {
    transform: rotate(-4deg) scale(1.06);
  }
}
.AboutValues_values__dJU9w .AboutValues_card__2Uuf2 h3 {
  font-size: 1.4rem;
  color: #14213d;
  margin: 0 0 15px;
  font-weight: 700;
  position: relative;
}
.AboutValues_values__dJU9w .AboutValues_card__2Uuf2 h3::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  width: 0%;
  height: 2px;
  border-radius: 2px;
  background: #1e2150;
  transition: width 0.35s ease;
}
@media (hover: hover) {
  .AboutValues_values__dJU9w .AboutValues_card__2Uuf2:hover h3::after {
    width: 55%;
  }
}
.AboutValues_values__dJU9w .AboutValues_card__2Uuf2 p {
  color: #555;
  font-size: 1rem;
  line-height: 1.7;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/styleAboutUs/AboutValues.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AACJ;AACI;EARF;IASI,qCAAA;EAEJ;AACF;AAAI;EAZF;IAaI,0BAAA;EAGJ;AACF;AAAE;EACE,gBAAA;EACA,mBAAA;EACA,0CAAA;EAEA,uBAAA;EAEA,kBAAA;EACA,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,uDAAA;EACA,sBAAA;EAEA,kBAAA;AAHJ;AAII;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,oBAAA;EAEA,uFAAA;EAMA,UAAA;EACA,8BAAA;AARN;AAxBE;EAmCE,uBAAA;AARJ;AASI;EACE;IACE,4BAAA;IACA,+GACQ;EARd;EAaI;IACE,UAAA;EAXN;AACF;AAcI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EAEA,mBAAA;EACA,gCAAA;AAfN;AAiBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAfR;AAmBI;EACE;IACE,oCAAA;EAjBN;AACF;AAoBI;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EAEA,kBAAA;AAnBN;AAqBM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;AAnBR;AAuBI;EACE;IACE,UAAA;EArBN;AACF;AAwBI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAtBN","sourcesContent":[".values {\r\n  background: #f8f9fb;\r\n  padding: 100px 0;\r\n\r\n  .grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 30px;\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 0 20px;\r\n\r\n    @media (max-width: 992px) {\r\n      grid-template-columns: repeat(2, 1fr);\r\n    }\r\n\r\n    @media (max-width: 700px) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n\r\n  .card {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n\r\n    padding: 40px 30px 40px;\r\n\r\n    position: relative;\r\n    text-align: center;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n\r\n    transition: transform 0.35s ease, box-shadow 0.35s ease;\r\n    will-change: transform;\r\n\r\n    /* shine overlay */\r\n    &::after {\r\n      content: \"\";\r\n      position: absolute;\r\n      inset: 0;\r\n      border-radius: 12px;\r\n      pointer-events: none;\r\n\r\n      background: radial-gradient(\r\n                      circle at 30% 20%,\r\n                      rgba(30, 33, 80, 0.12),\r\n                      transparent 55%\r\n      );\r\n\r\n      opacity: 0;\r\n      transition: opacity 0.35s ease;\r\n    }\r\n\r\n    /* hover only desktop */\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        transform: translateY(-10px);\r\n        box-shadow:\r\n                0 18px 40px rgba(0, 0, 0, 0.14),\r\n                0 0 0 2px rgba(30, 33, 80, 0.10),\r\n                0 0 26px rgba(158, 186, 68, 0.18);\r\n      }\r\n\r\n      &:hover::after {\r\n        opacity: 1;\r\n      }\r\n    }\r\n\r\n    .icon {\r\n      width: 90px;\r\n      height: 90px;\r\n      border-radius: 50%;\r\n\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n\r\n      position: static;\r\n      top: auto;\r\n      left: auto;\r\n      transform: none;\r\n\r\n      margin-bottom: 22px;\r\n      transition: transform 0.35s ease;\r\n\r\n      img {\r\n        width: 82px;\r\n        height: 82px;\r\n        object-fit: contain;\r\n      }\r\n    }\r\n\r\n    @media (hover: hover) {\r\n      &:hover .icon {\r\n        transform: rotate(-4deg) scale(1.06);\r\n      }\r\n    }\r\n\r\n    h3 {\r\n      font-size: 1.4rem;\r\n      color: #14213d;\r\n      margin: 0 0 15px;\r\n      font-weight: 700;\r\n\r\n      position: relative;\r\n\r\n      &::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 50%;\r\n        bottom: -10px;\r\n        transform: translateX(-50%);\r\n        width: 0%;\r\n        height: 2px;\r\n        border-radius: 2px;\r\n        background: #1e2150;\r\n        transition: width 0.35s ease;\r\n      }\r\n    }\r\n\r\n    @media (hover: hover) {\r\n      &:hover h3::after {\r\n        width: 55%;\r\n      }\r\n    }\r\n\r\n    p {\r\n      color: #555;\r\n      font-size: 1rem;\r\n      line-height: 1.7;\r\n      margin: 0;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"values": `AboutValues_values__dJU9w`,
	"grid": `AboutValues_grid__PLCBT`,
	"card": `AboutValues_card__2Uuf2`,
	"icon": `AboutValues_icon__w1VMS`
};
export default ___CSS_LOADER_EXPORT___;
